import { 
  Box, 
  Table, 
  TableBody, 
  TableCell, 
  TableContainer, 
  TableHead, 
  TableRow, 
  TablePagination,
} from '@mui/material';
import { Merchant } from '../type';
import { useState } from 'react';
import { formatDate } from '../utils/dateUtils';

interface MerchantTableProps {
  data: Merchant[];
  onMerchantSelect: (merchant: Merchant) => void;
}

export const MerchantTable = ({
  data,
  onMerchantSelect,
}: MerchantTableProps) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleChangePage = (_: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const pagedData = data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  return (
    <Box sx={{ width: '100%' }}>
      <TableContainer>
        <Table stickyHeader size="small">
            <TableHead>
              <TableRow>
                <TableCell>Merchant ID</TableCell>
                <TableCell>Merchant Name</TableCell>
                <TableCell>Merchant Image</TableCell>
                <TableCell>Category</TableCell>
                <TableCell>Recommendation</TableCell>
              </TableRow>
            </TableHead>
          <TableBody>
            {pagedData.map((row, index) => (
              <TableRow key={row.merchant_id || `merchant-${index}`} hover style={{ cursor: 'pointer' }} onClick={() => onMerchantSelect(row)}>
                <TableCell>{row.merchant_id}</TableCell>
                <TableCell>{row.merchant_name}</TableCell>
                <TableCell>{row.merchant_image_url}</TableCell>
                <TableCell>{row.category_code}</TableCell>
                <TableCell>
                  <Box
                    sx={{
                      display: 'inline-block',
                      px: 1,
                      py: 0.5,
                      borderRadius: 1,
                      fontSize: '0.75rem',
                      fontWeight: 'bold',
                      backgroundColor: row.recommended ? '#e8f5e8' : '#ffebee',
                      color: row.recommended ? '#2e7d32' : '#c62828',
                    }}
                  >
                    {row.recommended ? '전체추천' : ((row.allowedEnterprises?.length ?? 0) > 0 || (row.allowedUsers?.length ?? 0) > 0) ? '추천' : '비추천'}
                  </Box>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
          component="div"
          count={data.length}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          rowsPerPageOptions={[5, 10, 25, 50]}
        />
    </Box>
  );
}; 